/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';

export class HandoverPdfVoModel extends JSONable {

  date: DateTimeWithTimezoneModel | undefined = undefined;

  companyName: string | undefined = undefined;

  addressLine: string | undefined = undefined;

  city: string | undefined = undefined;

  state: string | undefined = undefined;

  country: string | undefined = undefined;

  postalCode: string | undefined = undefined;
}
